import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import moment from "moment";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import CountUp from "react-countup";

import Logo from "../../resources/logo.png";
import Colors from "../../constants/Colors";
import EvolutionChart from "./EvolutionChart";
import EvolutionChart2 from "./EvolutionChart2";

import "moment/locale/fr";
moment.locale("fr");

const dataTest = [
  {
    Actions: 0
  },
  {
    Actions: 34
  },
  {
    Actions: 84
  },
  {
    Actions: 94
  },
  {
    Actions: 124
  },
  {
    Actions: 165
  },
  {
    Actions: 200
  }
];

const getWeeklyData = allActions => {
  const result = {};
  allActions.forEach(el => {
    const week = moment(el.date).week();
    if (result[week]) {
      result[week].actions++;
    } else {
      result[week] = {
        actions: 1
      };
    }
    result[week].week = week;
    result[week].date = moment()
      .week(week)
      .format("D MMMM");
  });
  // Initial date -> 0 actions
  const finalArray = [{ actions: 0 }];
  Object.keys(result).forEach(el => {
    finalArray.push(result[el]);
  });
  finalArray.sort((a, b) => a.week - b.week);
  // cumulative
  finalArray.forEach((el, i) => {
    if (i > 0) {
      finalArray[i].actions += finalArray[i - 1].actions;
    }
  });
  if (allActions.length < 1) {
    return [
      {
        actions: 0
      },
      {
        actions: 0
      },
      {
        actions: 0
      },
      {
        actions: 0
      },
      {
        actions: 0
      },
      {
        actions: 0
      },
      {
        actions: 0
      }
    ];
  }
  return finalArray;
};

const styles = theme => ({
  main: {
    backgroundColor: "#FAFAFA",
    flex: 1,
    paddingRight: "5%",
    paddingLeft: "5%",
    paddingTop: 35,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center"
  },
  leftSection: {
    display: "flex",
    flex: 1,
    height: 250,
    marginRight: "5%",
    alignItems: "center",
    justifyContent: "center"
  },
  rightSection: {
    flex: 3,
    display: "flex",
    height: 250,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  companyLogo: {
    width: "40%"
  },
  accent: {
    color: "#6198DE"
  },
  rightTitle: {
    fontWeight: 500,
    marginBottom: 5
  },
  bold: {
    fontWeight: 500
  },
  totalDone: {
    color: "#fff",
    fontWeight: 500
  },
  actionLegend: {
    color: "#fff"
  },
  circle: {
    width: 200,
    height: 200,
    borderRadius: 100,
    webkitBoxShadow: "0px 0px 15px 2px rgba(66,80,251,1)",
    mozBoxShadow: "0px 0px 15px 2px rgba(66,80,251,1)",
    boxShadow: "0px 0px 15px 2px rgba(66,80,251,1)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: Colors.main
  },
  box: {
    webkitBoxShadow: "0px 0px 4px 1px #D8D8D8",
    mozBoxShadow: "0px 0px 4px 1px #D8D8D8",
    boxShadow: "0px 0px 4px 1px #D8D8D8",
    borderRadius: 10,
    // height: 200,
    width: "100%",
    padding: 10,
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 20
  },
  catchPhrase: {
    color: Colors.text,
    fontSize: "1.25rem",
    // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    // lineHeight: 1.6,
    letterSpacing: "0.0075em"
  }
});

const isNumber = n => {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

class KeyDataSection extends PureComponent {
  state = {
    name: "",
    owner: "",
    domain: ""
  };

  componentDidMount = () => {
    // this.props.getActionListRequest();
    // setTimeout(() => {
    //   this.setState({ data: this.props.weeklyData });
    // }, 300);
  };

  onChangeClient = event => {
    this.props.changeCreateField({ name: event.target.value });
  };

  onChangeEmail = event => {
    this.props.changeCreateField({ owner: event.target.value });
  };

  onChangeDomain = event => {
    this.props.changeCreateField({ domain: event.target.value });
  };

  onSubmit = () => {
    this.props.createClientRequest({
      name: this.props.name,
      owner: this.props.owner,
      domain: this.props.domain
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.main}>
        <Paper className={classes.box}>
          <p className={classes.catchPhrase}>
            <b>{this.props.totalActionsViews}</b> actions ont été enseignées
          </p>
          <p className={classes.catchPhrase}>
            <b>
              {`${(
                (this.props.totalOneGoodRate / this.props.totalEmployees) *
                100
              ).toFixed(0)}%`}
            </b>{" "}
            des utilisateurs ont mis au moins une note supérieure ou égale à 4/5
          </p>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { isFakeData, fakeData } = state.admin;
  const {
    owner,
    name,
    domain,
    createdAt,
    totalActionsViews,
    totalOneGoodRate,
    totalEmployees
  } = isFakeData ? fakeData : state.client;
  return {
    token: state.auth.token,
    createdAt,
    totalActionsViews,
    totalEmployees,
    totalOneGoodRate
  };
};

export default connect(
  mapStateToProps,
  {}
)(withStyles(styles)(KeyDataSection));
